(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[335],{

/***/ 3328:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact",
      function () {
        return __webpack_require__(1700);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8173:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8527);
/* harmony import */ var _Shared_ShizaiLogo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8271);



const ContactHeader = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                paddingTop: "3.5rem",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                    width: "100px",
                    height: "33px",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Shared_ShizaiLogo__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {})
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                marginTop: "2rem"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                as: "h3",
                fontWeight: 500,
                textStyle: "h3",
                children: "お問い合わせフォーム"
            })
        ]
    });
/* harmony default export */ __webpack_exports__["Z"] = (ContactHeader);


/***/ }),

/***/ 7596:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8527);



const ContactView = (param)=>{
    let { children  } = param;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const j = (nodeOrQuerySelector)=>{
            if (typeof nodeOrQuerySelector === "string") {
                return document.querySelector(nodeOrQuerySelector);
            }
            return nodeOrQuerySelector;
        };
        window.jQuery = window.jQuery || j;
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
        height: "max-content",
        width: {
            base: "100%",
            md: "100%",
            lg: "80%"
        },
        backgroundColor: "white",
        margin: "0 auto",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
            marginX: "2rem",
            paddingBottom: "4.5rem",
            children: children
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContactView);


/***/ }),

/***/ 3978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var public_images_top_ogp_png__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(792);
/* harmony import */ var public_images_top_ogp_png__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(public_images_top_ogp_png__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var public_icons_shizai_icon_png__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(455);
/* harmony import */ var public_icons_shizai_icon_png__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(public_icons_shizai_icon_png__WEBPACK_IMPORTED_MODULE_3__);
/* provided dependency */ var process = __webpack_require__(3454);




const defaultDescription = "shizaiは段ボールから、紙器や包装フィルムなどの商品パッケージまで、あらゆる梱包・包装資材の作成をサポートします。品質はそのままで平均20%のコスト削減を実現。";
const DefaultHead = (param)=>{
    let { title , description =defaultDescription , image , url , joinOriginToImage =false  } = param;
    let imageUrl = image;
    if (joinOriginToImage && image) {
        var _ORIGIN_PROTOCOL;
        const protocol = (_ORIGIN_PROTOCOL = process.env.ORIGIN_PROTOCOL) !== null && _ORIGIN_PROTOCOL !== void 0 ? _ORIGIN_PROTOCOL : "https";
        var _ORIGIN;
        const host = (_ORIGIN = "shiza1.com") !== null && _ORIGIN !== void 0 ? _ORIGIN : "localhost:5001";
        const builder = new URL("".concat(protocol, "://").concat(host, "/"));
        builder.pathname = image;
        imageUrl = builder.toString();
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: "https://".concat(url)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: imageUrl || "https://".concat("shiza1.com").concat((public_images_top_ogp_png__WEBPACK_IMPORTED_MODULE_2___default()))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: "shizai"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: imageUrl || "https://".concat("shiza1.com").concat((public_images_top_ogp_png__WEBPACK_IMPORTED_MODULE_2___default()))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "apple-mobile-web-app-title",
                content: "shizai"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "192x192",
                href: (public_icons_shizai_icon_png__WEBPACK_IMPORTED_MODULE_3___default())
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/png",
                href: "/icons/favicon.ico"
            }),
            url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: "https://".concat(url)
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DefaultHead);


/***/ }),

/***/ 8271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4651);
/* harmony import */ var public_images_shizai_logo_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9973);
/* harmony import */ var public_images_shizai_logo_svg__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(public_images_shizai_logo_svg__WEBPACK_IMPORTED_MODULE_2__);




const ShizaiLogo = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Img */ .Ei, {
        src: (public_images_shizai_logo_svg__WEBPACK_IMPORTED_MODULE_2___default()),
        w: "8rem",
        h: "2.5rem",
        alt: "shizaiのロゴ"
    }));
ShizaiLogo.displayName = "ShizaiLogo";
/* harmony default export */ __webpack_exports__["Z"] = (ShizaiLogo);


/***/ }),

/***/ 1700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ contact; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(8527);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/chakra-ui-button.esm.js
var chakra_ui_button_esm = __webpack_require__(5193);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/libs/gtag.ts
var gtag = __webpack_require__(7980);
;// CONCATENATED MODULE: ./src/components/Contact/ContactLink.tsx




const ContactLink = (param)=>/*#__PURE__*/ {
    let { title , href  } = param;
    return (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* LinkBox */.fG, {
        borderRadius: "0.5rem",
        layerStyle: "border",
        minHeight: "6rem",
        textDecoration: "none",
        _hover: {
            _hover: {
                backgroundColor: "primary.200"
            }
        },
        onClick: ()=>{
            (0,gtag/* sendClickLog */.VT)({
                category: gtag/* LogCategories.CONTACT */.Bn.CONTACT,
                label: title
            });
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: href,
            passHref: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                direction: {
                    base: "column",
                    md: "column",
                    lg: "row"
                },
                align: "center",
                justify: "space-between",
                padding: "1.5rem",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                        textStyle: "body2",
                        color: "textGray.87",
                        fontWeight: 500,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_button_esm/* Button */.zx, {
                        marginX: {
                            base: "1.5rem",
                            md: "1.5rem",
                            lg: 0
                        },
                        marginTop: {
                            base: "1.5rem",
                            md: "1.5rem",
                            lg: 0
                        },
                        size: "sm",
                        height: "3rem",
                        width: {
                            base: "100%",
                            md: "100%",
                            lg: "10rem"
                        },
                        children: "選択"
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Contact_ContactLink = (ContactLink);

// EXTERNAL MODULE: ./src/components/Contact/ContactView.tsx
var ContactView = __webpack_require__(7596);
// EXTERNAL MODULE: ./src/components/Contact/ContactHeader.tsx
var ContactHeader = __webpack_require__(8173);
// EXTERNAL MODULE: ./src/constants/paths.ts
var paths = __webpack_require__(1685);
// EXTERNAL MODULE: ./src/components/DefaultHead.tsx
var DefaultHead = __webpack_require__(3978);
;// CONCATENATED MODULE: ./src/pages/contact/index.tsx







const ContactDetailPages = [
    {
        title: "パッケージに関するお問い合わせ",
        href: paths/* paths.contactPackage */.Hb.contactPackage
    },
    {
        title: "その他",
        href: paths/* paths.contactOther */.Hb.contactOther
    }
];
const Index = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(ContactView/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactHeader/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultHead/* default */.Z, {
                title: "問い合わせ - shizai",
                description: "shizaiはオリジナルパッケージを低コスト・高品質で作れるプラットフォームです。ECで必要なパッケージの見積もりをかんたんに取得できます。",
                url: "shiza1.com" + paths/* paths.contact */.Hb.contact
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                marginTop: "3rem"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                textStyle: "body2",
                color: "primary.500",
                children: "お問い合わせいただきありがとうございます。以下より選択肢をお選びください。"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                marginY: "2rem",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                    textStyle: "subtitle",
                    children: "お問い合わせ内容"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Stack */.Kq, {
                spacing: "2rem",
                children: ContactDetailPages.map((page)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Contact_ContactLink, {
                        ...page
                    }, page.href))
            })
        ]
    });
var __N_SSG = true;
/* harmony default export */ var contact = (Index);


/***/ }),

/***/ 455:
/***/ (function(module) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 792:
/***/ (function(module) {

module.exports = "/_next/static/images/top_ogp-4595dbbf98aa97507258d07dfa1f0ecb.png";

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(3328); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);